const thumbSwiper = new Swiper('.thumbs-container', {
  spaceBetween: 15,
  slidesPerView: 6,
  breakpoints: { 
    768: {
      touchRatio: 0,
      spaceBetween: 8,
    }
  },
  navigation: {
    nextEl: '.gallery.swiper-button-next',
    prevEl: '.gallery.swiper-button-prev',
  },
});
   
const mainSwiper = new Swiper('.main-container', {
  slidesPerView: 1,
  autoHeight: true,
  loop: true,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
  },
  thumbs: {
    swiper: thumbSwiper
  },
  navigation: {
    nextEl: '.mainimg.swiper-button-next',
    prevEl: '.mainimg.swiper-button-prev',
  },
});

refreshFsLightbox();